import { render, staticRenderFns } from "./rectangle.vue?vue&type=template&id=75d97789&scoped=true&"
import script from "./rectangle.vue?vue&type=script&lang=js&"
export * from "./rectangle.vue?vue&type=script&lang=js&"
import style0 from "./rectangle.vue?vue&type=style&index=0&id=75d97789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d97789",
  null
  
)

export default component.exports